import { PROVIDER_ID } from 'wallet/index'
import Button from 'components/Button'
import { SvgImg } from 'components/SvgImg'
import type { Account } from 'wallet/index'
import AccountsList from 'components/ConnectWallet/AccountsList'
import Label from 'components/ConnectWallet/Label'

type WalletButtonProps = {
  providerId: PROVIDER_ID
  name: string
  icon: string
  accounts: Account[]
  activeAccount: Account | null
  isConnected: boolean
  isActive: boolean
  handleConnectWallet: (walletId: PROVIDER_ID | null) => Promise<void>
  handleDisconnectWallet: (walletId: PROVIDER_ID) => Promise<void>
  handleSetActiveAccount: (account: Account) => void
}

export default function WalletButton({
  providerId,
  name,
  icon,
  accounts,
  activeAccount,
  isActive,
  isConnected,
  handleConnectWallet,
  handleDisconnectWallet,
  handleSetActiveAccount
}: WalletButtonProps) {
  return (
    <>
      <button
        type="button"
        onClick={() => {
          if (!isConnected) handleConnectWallet(providerId)
          if (!isActive) handleSetActiveAccount(accounts[0])
        }}
        className="block bg-white border border-gray-300 shadow-sm text-base font-medium text-gray-700 hover:text-gray-500 text-left rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900"
      >
        <div className="block sm:flex sm:items-center px-4 py-4 sm:px-6">
          <div className="flex-1 flex items-center h-20">
            <div className="flex-shrink-0 ring-1 ring-gray-300 rounded-full overflow-hidden">
              <SvgImg use={icon} size={4} />
            </div>
            <div className="flex-1 px-4">
              <div>
                <p className="text-base font-semibold text-gray-600">
                  <span className="mr-2">{name}</span>{' '}
                  {isActive ? (
                    <Label label="Active" color="blue" />
                  ) : isConnected ? (
                    <Label label="Connected" color="green" />
                  ) : (
                    <Label label="Not Connected" color="gray" />
                  )}
                </p>
                {accounts.length > 0 && isActive && (
                  <p className="mt-2 flex items-center text-sm text-gray-500">
                    <AccountsList
                      accounts={accounts}
                      activeAccount={activeAccount as Account}
                      handleSetActiveAccount={handleSetActiveAccount}
                    />
                  </p>
                )}
              </div>
            </div>
          </div>
          <div>
            {isConnected && (
              <Button
                variant="primary"
                size="lg"
                className="bg-red-600 hover:bg-red-700 focus:ring-red-500 mt-3 w-full sm:mt-0 sm:w-auto sm:text-sm"
                onClick={() => handleDisconnectWallet(providerId)}
              >
                Disconnect
              </Button>
            )}
          </div>
        </div>
      </button>
    </>
  )
}
